import api from '@/services/api'
import useLoading from '@/composables/useLoading'
import useResponse from '@/composables/useResponse'
import { computed, ref, watch } from '@vue/composition-api'

export default function useWarehouse() {
  const list = ref([])
  const pagination = ref({
    page: 1,
    perPage: 10,
    totalPage: 1,
  })

  const { isLoading, startLoading, finishLoading } = useLoading()

  const tableColumns = [
    { key: 'id', label: '#' },
    { key: 'name', label: 'Name' },
    { key: 'actions', label: 'Actions' },
  ]

  const paginationMeta = computed(() => ({
    from: pagination.value.perPage * (pagination.value.page - 1) + (list.value.length ? 1 : 0),
    to: pagination.value.perPage * (pagination.value.page - 1) + list.value.length,
    of: pagination.value.totalPage,
  }))

  // eslint-disable-next-line no-use-before-define
  watch(() => pagination.value.page, findAll)

  async function findAll() {
    try {
      startLoading()
      const response = useResponse(
        await api.warehouse.findAll({
          params: {
            page: pagination.value.page,
            limit: pagination.value.perPage,
          },
        }),
      )
      list.value = response.documents
      pagination.value.totalPage = response.pagination.totalPage
    } finally {
      finishLoading()
    }
  }

  function findOne({ id }) {
    return api.warehouse.findOne({ id })
  }

  function create({ body }) {
    return api.warehouse.create(body)
  }

  function edit({ id, body }) {
    return api.warehouse.edit({ id, body })
  }

  return {
    list,
    pagination,
    paginationMeta,
    tableColumns,
    isLoading,

    create,
    edit,
    findOne,
    findAll,
  }
}
